var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 0.399902C3.80263 0.399902 0.399994 3.80254 0.399994 7.9999C0.399994 12.1973 3.80263 15.5999 7.99999 15.5999C12.1974 15.5999 15.6 12.1973 15.6 7.9999C15.6 3.80254 12.1974 0.399902 7.99999 0.399902ZM8.36983 13.4624H7.63016C7.30974 13.4624 7.04999 13.2027 7.04999 12.8822V12.1426C7.04999 11.8222 7.30974 11.5624 7.63016 11.5624H8.36983C8.69025 11.5624 8.94999 11.8222 8.94999 12.1426V12.8822C8.94999 13.2027 8.69025 13.4624 8.36983 13.4624ZM9.45824 9.08924C9.12876 9.27613 8.93229 9.63235 8.94999 10.0107C8.91584 10.2439 8.71515 10.4162 8.47954 10.4147L7.52672 10.4088C7.33532 10.4076 7.16355 10.2911 7.0917 10.1137L7.04999 10.0107C7.03407 8.90715 7.64348 7.88943 8.62383 7.3824C9.11439 7.14354 9.42549 6.64553 9.42499 6.0999C9.40502 5.32132 8.77858 4.69488 7.99999 4.6749C7.36547 4.6749 6.82781 5.08962 6.64329 5.66279C6.56074 5.91924 6.33193 6.0999 6.06253 6.0999H5.34819C4.9653 6.0999 4.67132 5.74703 4.75463 5.37331C5.08606 3.88641 6.41322 2.7749 7.99999 2.7749C9.82636 2.79878 11.3011 4.27354 11.325 6.0999C11.3304 7.37271 10.6043 8.53548 9.45824 9.08924Z",
    fill: "#E82C5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueries);
export default __webpack_public_path__ + "static/media/Queries.78280c8c03cd551978b6f808cd30946c.svg";
export { ForwardRef as ReactComponent };